export default __webpack_public_path__ + "images/VU.9ae19ef.png";